import React from 'react'

const LeadershipPage = () => {
  return (
    <div > </div>
  )
}

export default LeadershipPage